// thx to https://codepen.io/nopr/pen/DWrOBm
import $ from "jquery";
import escape from "./helpers/escape.js";

const carousel = document.querySelector(".demo-carousel");
const items = carousel.querySelectorAll(".demo-carousel__item");
// const degIncr = 1/5 * 360;
let currDeg = 0;
let advancementIncr = 0;

// const rotate = (e) => {
//   if (e.data.d == "n") {
//     currDeg = currDeg - degIncr;
//     if(currDeg >= 360) currDeg = 0;
//   }
//   if (e.data.d == "p") {
//     currDeg = currDeg + degIncr;
//   }

//   carousel.style.setProperty("--demo-carousel-rotation", "rotateY(" + currDeg + "deg)");
// }

// $(".next").on("click", { d: "n" }, rotate);
// $(".prev").on("click", { d: "p" }, rotate);

const getSelectectedIdx = () =>
  advancementIncr % items.length === 0
    ? 0
    : items.length - (advancementIncr % items.length);

const advanceCarousel = () => {
  advancementIncr++;
  currDeg = Math.round((advancementIncr / items.length) * 360);
  console.log(currDeg, advancementIncr % items.length);
  Array.from(items).forEach((item) => {
    item.classList.remove("selected");
  });

  carousel.style.setProperty(
    "--demo-carousel-rotation",
    "rotateY(" + currDeg + "deg)"
  );

  const makeSelected = () => {
    carousel.removeEventListener("transitionend", makeSelected);
    const selectedIdx = getSelectectedIdx();
    items[selectedIdx].classList.add("selected");
  };

  carousel.addEventListener("transitionend", makeSelected);
};

const init = () => {
  items[0].classList.add("selected");
};

// on shift rotate carousel
document.addEventListener("keyup", (e) => {
  e.preventDefault();
  ["Shift", "ShiftLeft", "ShiftRight"].includes(e.code) && advanceCarousel();

  // if key pressed is spacebar, navigate to the selected item's link href attribute
  e.code === "Space" &&
    window.location.assign(
      items[getSelectectedIdx()].querySelector("a").getAttribute("href")
    );
});

init();

escape("/");
